/**
 * Admin Static Ads — `/admin/static-ads`
 *
 * Admin-gated entry to the Static Ad Generator. Renders the shared <StaticAdGenerator/> (same
 * component the consumer `/ads/static` route uses, so the two never drift). Drives the staticAds.*
 * router — the same backend as the build-vidmax-static-ads skill.
 *
 * @feature-spec brain/vidmax/feature-specs/static-ad-generator.spec.md
 */
import { createFileRoute } from "@tanstack/react-router"

import CustomHead from "~/components/SEOHead/CustomHead"
import { StaticAdGenerator } from "~/components/StaticAds/StaticAdGenerator"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

function StaticAdsAdminPage() {
  return (
    <SuperAdminLayout>
      <CustomHead title="Static Ads" />
      <StaticAdGenerator />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/static-ads")({ component: StaticAdsAdminPage })
